module.exports = "- Announce status during progress unless the time has gone over a specified threshold.\n"